<template>
  <div class="tw-flex tw-flex-1 tw-flex-col tw-justify-between">
    <div class="tw-mt-6">
      <router-link slot="brand" class="navbar-brand tw-block lg:tw-hidden" to="/">
        <img src='@/assets/barter-full.png' alt='logobarter'>
      </router-link>
      <h1 class="tw-text-2xl lg:tw-text-3xl">Connections</h1>
    </div>
    <div class="tw-flex tw-flex-1 tw-flex-col tw-justify-start tw-gap-y-3 tw-mb-6">
      <tw-stats-card
        title="API URL"
        :subtitle="VUE_APP_API_URL"
        icon="fas fa-compass"
        type="primary"
      />
      <tw-stats-card
        title="END POINT"
        :subtitle="VUE_APP_END_POINT"
        icon="fas fa-circle-info"
        type="warning"
      />
      <tw-stats-card
        title="PUBLIC URL"
        :subtitle="VUE_APP_PUBLIC_URL"
        icon="fas fa-earth-asia"
        type="success"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'connections',
  data() {
    return {
      VUE_APP_API_URL: process.env.VUE_APP_API_URL,
      VUE_APP_END_POINT: process.env.VUE_APP_END_POINT,
      VUE_APP_PUBLIC_URL: process.env.VUE_APP_PUBLIC_URL
    }
  }
}
</script>
